import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNavigation.css';
import {
  CustomSettingsIcon as SettingsIcon,
  TrophyIcon,
  MedalIcon,
  ScheduleIcon,
  ChartBarIcon
} from './FencingIcons';

/**
 * BottomNavigation component - Barra di navigazione fissa in basso per dispositivi mobili
 * Mostra le sezioni principali dell'app per un accesso rapido
 */
const BottomNavigation = () => {
  const location = useLocation();
  // Stato per verificare se c'è una competizione attiva
  const [hasActiveCompetition, setHasActiveCompetition] = useState(false);


  // Ottieni il tipo di competizione corrente per la configurazione
  const [competitionType, setCompetitionType] = useState(() => {
    return localStorage.getItem('competitionType') || 'team';
  });

  // Controlla periodicamente se c'è una competizione attiva
  useEffect(() => {
    const checkCompetitionStatus = () => {
      // Controlla se c'è una competizione attiva (teams o matches esistenti)
      const teams = JSON.parse(localStorage.getItem('teams')) || [];
      const matches = JSON.parse(localStorage.getItem('matches')) || [];
      const hasCompetition = teams.length > 0 || matches.length > 0;
      setHasActiveCompetition(hasCompetition);
    };

    // Controlla subito
    checkCompetitionStatus();

    // Imposta un intervallo per controllare periodicamente
    const interval = setInterval(checkCompetitionStatus, 1000);

    // Pulisci l'intervallo quando il componente viene smontato
    return () => clearInterval(interval);
  }, []); // Esegui solo all'avvio



  // Controlla il tipo di competizione (e aggiorna dinamicamente)
  useEffect(() => {
    const checkCompetitionType = () => {
      const storedType = localStorage.getItem('competitionType');
      if (storedType && storedType !== competitionType) {
        setCompetitionType(storedType);
      }
    };

    // Controlla subito
    checkCompetitionType();

    // Controlla periodicamente (1 secondo)
    const interval = setInterval(checkCompetitionType, 1000);

    // Ascolta anche eventi di storage per aggiornamenti cross-tab
    window.addEventListener('storage', checkCompetitionType);

    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', checkCompetitionType);
    };
  }, [location.pathname, competitionType]); // Riesegui quando cambia la route o il tipo di gara

  // Mostra solo se c'è competizione attiva, indipendentemente dalla dimensione dello schermo
  if (!hasActiveCompetition) {
    return null;
  }

  // Determina l'URL di configurazione in base al tipo di competizione
  const getConfigUrl = () => {
    switch (competitionType) {
      case 'individual':
        return '/config-individuale';
      case 'mixed':
        return '/config-miste';
      default:
        return '/config-squadre';
    }
  };

  // Definizione dei pulsanti della navigation bar (ricalcolato quando cambia competitionType)
  const configUrl = getConfigUrl();
  console.log('[BottomNavigation] competitionType:', competitionType, '-> configUrl:', configUrl);
  const navItems = [
    { to: configUrl, label: 'Config', icon: SettingsIcon },
    { to: '/schedule', label: 'Assalti', icon: ScheduleIcon },
    { to: '/table', label: 'Girone', icon: ChartBarIcon },
    { to: '/bracket', label: 'Elim.', icon: TrophyIcon },
    { to: '/final-ranking', label: 'Classifica', icon: MedalIcon },
  ];

  // Non abbiamo più bisogno di aprire il drawer

  return (
    <div className="bottom-nav">
      <div className="bottom-nav-container">
        {navItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`bottom-nav-item ${location.pathname === item.to ? 'active' : ''}`}
          >
            <div className="bottom-nav-icon"><item.icon /></div>
            <div className="bottom-nav-label">{item.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;
